import categories from 'src/json/categories.json'
import products from 'src/json/products.json'

const getProductsBySelection = (selection, brand) => {
  let items = []

  if (selection) {
    switch (selection.fields.filterBy) {
      case "Product id's":
        if (selection.fields.productIds) {
          items = products.filter(product =>
            selection.fields.productIds.includes(product.product)
          )
        }
        if (brand) {
          items = items.filter(product => product.brand === brand)
        }
        break
      case 'Category id':
        const cat = categories.find(
          category =>
            parseInt(category.category) ===
            parseInt(selection.fields.categoryId)
        )
        if (cat) {
          items = products.filter(product =>
            cat.products.includes(product.product)
          )
        }
        if (brand) {
          items = items.filter(product => product.brand === brand)
        }
      default:
        break
    }
  }

  return items
}

export default getProductsBySelection
